<template>
    <tasks-destroy
        :params="{
            task: task.uuid
        }"
        v-slot="{
            sid,
            is_loading: is_saving,
            has_loaded: has_saved,
            error,
            destroy
        }"
        @success="onTasksDestroy"
    >
        <div>
            <error-modal
                v-if="error"
                :error="error"
            />

            <modal-success
                v-else-if="show_destroyed_modal"
                :is-open="show_destroyed_modal"
                @close="closeAll(); $emit('success')"
            >
                <template slot="heading">Task Deleted!</template>

                <p>Task successfully deleted.</p>

                <div
                    slot="footer"
                    slot-scope="{ close }"
                    class="flex flex-col md:flex-row-reverse"
                >
                    <button
                        type="button"
                        @click.prevent="close"
                        class="text-center btn"
                    >
                        Close
                    </button>
                </div>
            </modal-success>

            <modal-red
                v-else-if="show_destroy_modal"
                :is-open="show_destroy_modal"
                @close="closeAll"
            >
                <base-form
                    slot-scope="{ close }"
                    @submit="destroy"
                >
                    <div class="px-4 pt-4 pb-3 sm:p-6">
                        <h6 class="mb-3 text-lg font-normal font-semibold text-center">
                            Delete Task
                        </h6>

                        <div class="text-grey-darker">
                            <p class="mb-3">Are you sure you want to delete this task?</p>

                            <p><strong>Warning: </strong>You cannot undo this action!</p>
                        </div>
                    </div>

                    <footer class="flex flex-col px-6 py-3 rounded-b md:flex-row-reverse bg-grey-bg">
                        <base-button
                            :is-loading="is_saving"
                            type="submit"
                            class="w-full btn btn-red md:w-auto"
                        >
                            Delete Task
                        </base-button>

                        <button
                            type="button"
                            class="text-center btn md:mr-3"
                            @click.prevent="close"
                        >
                            Cancel
                        </button>
                    </footer>
                </base-form>
            </modal-red>
        </div>
    </tasks-destroy>
</template>

<script>
    import TasksDestroy from './tasks-destroy'

    export default {
        components: {
            TasksDestroy
        },
        model: {
            prop: 'toggled',
            event: 'toggle'
        },
        props: {
            toggled: {
                type: Boolean,
                required: true
            },
            task: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                show_destroy_modal: false,
                show_destroyed_modal: false
            }
        },
        watch: {
            toggled () {
                this.show_destroy_modal = this.toggled
            }
        },
        methods: {
            closeAll () {
                this.show_destroyed_modal = false
                this.show_destroy_modal = false

                this.$emit('toggle', false)
            },
            onButtonClick () {
                this.$emit('open')

                setTimeout(() => {
                    this.show_destroy_modal = true
                }, 0)
            },
            onTasksDestroy () {
                setTimeout(() => {
                    this.show_destroy_modal = false

                    setTimeout(() => {
                        this.show_destroyed_modal = true
                    }, 0)
                }, 0)
            }
        }
    }
</script>
